import { createContext } from 'react'

const SearchFilterContext = createContext(
  {} as {
    filterState: number
    setFilter: (filter?: number) => void
  }
)

export default SearchFilterContext
